import * as _ from 'lodash-es';

import {getPublicationsListForComponent} from '@app/components/publications/store/publications/publications.selector';
import {createSelector} from '@ngrx/store';

export const getPublicationInfos = createSelector(
  getPublicationsListForComponent,
  (pubList) => (criterias: { uuid: string }) => {
    return _.filter(pubList.publications, (aPub) => {
      return (aPub as any).uuid === criterias.uuid;
    })[0];
  },
);
